import React, { PureComponent } from 'react';
import { Table, Popup } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import InsightsListItem from './InsightsListItem';

class InsightsList extends PureComponent {
  state = {
    path: `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }`,
    refreshingExpirationIds: [],
    refreshExpiration: null,
    showConfirm: false
  };

  onCopy = (text) => {
    const urlParts = text.split('/');
    this.setState({ copied: urlParts[urlParts.length - 1] });
    toast.success(`URL copied to clipboard.`, {
      position: 'bottom-center',
      autoClose: 3250,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    setTimeout(() => {
      this.setState({ copied: null });
    }, 5000);
  };

  openDialog = (e, { data }) => {
    this.setState({ showConfirm: true, deleteRowId: data.id });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  mouseEnter = (e) => {
    const id = parseInt(e.target.id, 10);
    this.setState({ refreshExpiration: id });
  };

  mouseLeave = () => {
    this.setState({ refreshExpiration: null });
  };

  updateExpiration = async (iframe) => {
    const { updateIframe } = this.props;
    const { id: iframeId, expired_at: expiredAt } = iframe;
    const { refreshingExpirationIds } = this.state;
    const newIframe = iframe;
    this.setState(
      {
        refreshingExpirationIds: [...refreshingExpirationIds, iframeId]
      },
      async () => {
        const {
          refreshingExpirationIds: newRefreshingExpirationIds
        } = this.state;
        let expirationDate = new Date(expiredAt);
        const today = new Date();

        if (expirationDate <= today) {
          today.setDate(today.getDate() + 7);
          expirationDate = today;
        } else {
          const todayPlusMonth = new Date();
          todayPlusMonth.setDate(today.getDate() + 30);
          expirationDate.setDate(expirationDate.getDate() + 7);

          if (expirationDate > todayPlusMonth) {
            expirationDate = todayPlusMonth;
          }
        }
        newIframe.expired_at = expirationDate.toISOString().split('T')[0];
        const { id: newId, expired_at: newExpiredAt } = newIframe;
        await updateIframe(newIframe);
        const ids = newRefreshingExpirationIds;
        ids.splice(ids.indexOf(newId), 1);
        this.setState({ refreshingExpirationIds: ids });
        toast.success(
          `Iframe expiration update from ${expiredAt} to ${newExpiredAt}`,
          {
            position: 'bottom-center',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          }
        );
      }
    );
  };

  handleConfirm = async () => {
    const { removeIframe } = this.props;
    const { deleteRowId } = this.state;
    await removeIframe(deleteRowId);
    toast.error(`Iframe Deleted`, {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };

  showDashboards = (dashboardsIds) => {
    const { dashboards } = this.props;
    if (!dashboardsIds) {
      return '';
    }

    const ids = dashboardsIds.split(',');
    let dashboardNames = '';
    ids.forEach((id) => {
      const dashboard = dashboards.find(
        (item) => item.value === parseInt(id, 10)
      );
      if (dashboard) {
        const { text } = dashboard;
        dashboardNames += dashboardNames === '' ? text : `, ${text}`;
      }
    });

    return dashboardNames;
  };

  render() {
    const { iframes, updateIframe } = this.props;
    const {
      path,
      copied,
      refreshExpiration,
      refreshingExpirationIds,
      showConfirm,
      deleteRowId
    } = this.state;
    return (
      <div>
        <Table celled stackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Permissions</Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Dashboards</Table.HeaderCell>
              <Table.HeaderCell>Created By</Table.HeaderCell>
              <Table.HeaderCell>Created At</Table.HeaderCell>
              <Table.HeaderCell>Updated At</Table.HeaderCell>
              <Table.HeaderCell className="col-expiration">
                Expiration
              </Table.HeaderCell>
              <Table.HeaderCell>
                <div className="div-confirm">
                  Edit/Delete
                  <Popup
                    trigger={<i className="info circle icon" />}
                    content="Editing will allow you to update the share link. Deleting will invalidate this link for all clients its been shared with."
                    position="top right"
                  />
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {iframes.map((iframe) => {
              return (
                <InsightsListItem
                  iframe={iframe}
                  path={path}
                  copied={copied}
                  refreshExpiration={refreshExpiration}
                  refreshingExpirationIds={refreshingExpirationIds}
                  showConfirm={showConfirm}
                  deleteRowId={deleteRowId}
                  onCopy={this.onCopy}
                  showDashboards={this.showDashboards}
                  mouseEnter={this.mouseEnter}
                  mouseLeave={this.mouseLeave}
                  updateExpiration={this.updateExpiration}
                  handleConfirm={this.handleConfirm}
                  handleCancel={this.handleCancel}
                  openDialog={this.openDialog}
                  updateIframe={updateIframe}
                />
              );
            })}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default InsightsList;



// WEBPACK FOOTER //
// ./src/screens/InsightsPreview/InsightsList.js